/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	BlockedAccessRestrictionsQuery$data as BlockedAccessRestrictionsQuery,
	BlockedAccessRestrictionsQuery$variables as BlockedAccessRestrictionsQueryVariables,
} from '../__generated__/BlockedAccessRestrictionsQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { BlockedAccessRestrictionsQuery$data } from '../__generated__/BlockedAccessRestrictionsQuery.graphql.ts';
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_subject = NonNullable<NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessRestrictionSummary'][number]>['subject']>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources_resourceLink = NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessRestrictionSummary'][number]>['restrictedResources']>[number]>['resourceLink']>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources = NonNullable<NonNullable<NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessRestrictionSummary'][number]>['restrictedResources']>[number]>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary = NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessRestrictionSummary'][number]>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessEmpowerment = NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessEmpowerment'][number]>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessAssignableSpaceRolesIntersection = NonNullable<NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>['blockedAccessAssignableSpaceRolesIntersection'][number]>;
export type BlockedAccessRestrictionsQuery_blockedAccessRestrictions = NonNullable<BlockedAccessRestrictionsQuery$data['blockedAccessRestrictions']>;

// GraphQL input types re-exported from Relay artifact
export type { BlockedAccessSubjectInput } from '../__generated__/BlockedAccessRestrictionsQuery.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum BlockedAccessSubjectType {
  GROUP = "GROUP",
  USER = "USER",
}

export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export enum ResourceType {
  DATABASE = "DATABASE",
  FOLDER = "FOLDER",
  PAGE = "PAGE",
  SPACE = "SPACE",
  WHITEBOARD = "WHITEBOARD",
}

export enum SpaceRoleType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}

